import { Svg } from 'components/svg'

export const IconSoundOffCircle = () => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{ overflow: 'visible' }}
  >
    <path
      d="M-559-44a5.006,5.006,0,0,1-5-5,5.006,5.006,0,0,1,5-5,5.006,5.006,0,0,1,5,5A5.005,5.005,0,0,1-559-44Zm0-3.939h0l1.608,1.608a.745.745,0,0,0,.53.22.742.742,0,0,0,.53-.22.743.743,0,0,0,.22-.53.744.744,0,0,0-.22-.53L-557.94-49l1.608-1.608a.744.744,0,0,0,.22-.53.744.744,0,0,0-.22-.53.743.743,0,0,0-.53-.22.743.743,0,0,0-.53.22L-559-50.06l-1.608-1.608a.744.744,0,0,0-.53-.22.744.744,0,0,0-.53.22.745.745,0,0,0-.219.53.745.745,0,0,0,.219.53L-560.06-49l-1.608,1.608a.745.745,0,0,0-.219.53.745.745,0,0,0,.219.53.745.745,0,0,0,.53.22.742.742,0,0,0,.53-.22L-559-47.939Z"
      transform="translate(578 61)"
      fill="#f90008"
    />
    <g transform="translate(-0.848 0.07)">
      <path
        d="M11.848,4a1,1,0,0,1,1,1V19a1,1,0,0,1-1.625.781L6.5,16H2.848a1,1,0,0,1-1-1V9a1,1,0,0,1,1-1H6.5l4.726-3.781A1,1,0,0,1,11.848,4Zm-1,12.919V7.081l-3.375,2.7A1,1,0,0,1,6.848,10h-3v4h3a1,1,0,0,1,.625.219Z"
        fill="currentColor"
      />
    </g>
  </Svg>
)
